// Function to get API URL from environment or fallback to window.location.hostname
function getApiUrl(): string {
  // Try to get API URL from various sources
  let apiUrl = null;
  
  // 1. Try to get from window object (set by config.js)
  if ((window as any).API_URL) {
    apiUrl = (window as any).API_URL;
  }
  // 2. Try to get from localStorage
  else if (localStorage.getItem('API_URL')) {
    apiUrl = localStorage.getItem('API_URL');
  }
  // 3. Try to get from URL parameters
  else {
    const urlParams = new URLSearchParams(window.location.search);
    apiUrl = urlParams.get('apiUrl');
  }
  
  if (apiUrl) {
    console.log('🔧 Using API_URL from configuration:', apiUrl);
    
    // Check if URL already includes protocol (http:// or https://)
    if (apiUrl.startsWith('http://') || apiUrl.startsWith('https://')) {
      // URL already has protocol, just append /api if not present
      return apiUrl.endsWith('/api') ? apiUrl : `${apiUrl}/api`;
    } else {
      // Determine protocol based on current page protocol or default to http
      // If current page is HTTPS, use HTTPS for API (unless explicitly configured otherwise)
      const protocol = window.location.protocol === 'https:' ? 'https:' : 'http:';
      return `${protocol}//${apiUrl}/api`;
    }
  }
  
  // Fallback to window.location.hostname (default behavior)
  const defaultUrl = `${window.location.protocol}//${window.location.hostname}:8080/api`;
  console.log('🔧 Using default API URL:', defaultUrl);
  return defaultUrl;
}

// Function to get EMAIL_TEMPLATE_URL from environment
function getEmailTemplateUrl(): string {
  // Try to get EMAIL_TEMPLATE_URL from various sources
  let emailTemplateUrl = null;
  
  // 1. Try to get from window object (set by config.js)
  if ((window as any).EMAIL_TEMPLATE_URL) {
    emailTemplateUrl = (window as any).EMAIL_TEMPLATE_URL;
  }
  // 2. Try to get from localStorage
  else if (localStorage.getItem('EMAIL_TEMPLATE_URL')) {
    emailTemplateUrl = localStorage.getItem('EMAIL_TEMPLATE_URL');
  }
  
  if (emailTemplateUrl) {
    console.log('🔧 Using EMAIL_TEMPLATE_URL from configuration:', emailTemplateUrl);
    return emailTemplateUrl;
  }
  
  // Fallback to current location
  const defaultUrl = window.location.origin;
  console.log('🔧 Using default EMAIL_TEMPLATE_URL:', defaultUrl);
  return defaultUrl;
}

export const environment = {
  production: false,
  // Use getter function to evaluate at runtime, not at module load time
  get apiUrl(): string {
    return getApiUrl();
  },
  get emailTemplateUrl(): string {
    return getEmailTemplateUrl();
  },
  
  // URLs for different development scenarios
  urls: {
    local: '/api',
    lan: '/api'
  }
}; 